module.exports = __webpack_public_path__ + "img/9.223a68dc.png";